function defaultAddHeaderClass(){

	(function($) {

		var header = $('.header'),
	      mobileTest;

	      /* ---------------------------------------------- /*
	      * Mobile detect
	      /* ---------------------------------------------- */

	      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		      mobileTest = true;
	      } else {
	            mobileTest = false;
	      }

		function navbarAnimation() {
		  if ($(window).scrollTop() > 80) {
		      header.addClass('header-small');
		  } else {
		      header.removeClass('header-small');
		  }
		}

		navbarAnimation();

		$(window).scroll(function() {
		  navbarAnimation();
		});

	})( jQuery );

}
